import type { VideoData } from 'ricos-schema';
import { Node_Type } from 'ricos-schema';

import type { NodeBuilder } from './types';

export const video = (...args: (NodeBuilder | VideoData)[]): NodeBuilder => {
  const videoData = args.find((a): a is VideoData => !('type' in a));
  const nodeBuilders = args.filter((a): a is NodeBuilder => 'type' in a && a.type === 'block_node');

  return {
    type: 'block_node',
    // @ts-expect-error
    node: getId => ({
      id: getId(),
      type: Node_Type.VIDEO,
      ...(nodeBuilders.length && {
        nodes: nodeBuilders.map(nb => nb.node(getId)),
      }),
      videoData: videoData ? videoData : {},
    }),
  };
};
